












import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
  name: 'i-zoom',

})
export default class IZoom extends Vue {

  @Prop({type: [Boolean], default: true}) protected plus!: boolean

}

